var _path, _path2, _path3, _ellipse, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 12.2168C34.5 12.3081 34.434 12.5545 34.2014 12.9729C33.9822 13.3674 33.6509 13.8522 33.2143 14.396C32.3421 15.4823 31.0741 16.7738 29.5093 18.0122C26.3714 20.4956 22.1037 22.7168 17.5 22.7168C12.8963 22.7168 8.62857 20.4956 5.49074 18.0122C3.92592 16.7738 2.65787 15.4823 1.78568 14.396C1.34909 13.8522 1.01784 13.3674 0.798568 12.9729C0.56603 12.5545 0.5 12.3081 0.5 12.2168C0.5 12.1255 0.56603 11.8791 0.798568 11.4607C1.01784 11.0662 1.34909 10.5814 1.78568 10.0376C2.65787 8.95131 3.92592 7.65982 5.49074 6.42136C8.62857 3.93798 12.8963 1.7168 17.5 1.7168C22.1037 1.7168 26.3714 3.93798 29.5093 6.42136C31.0741 7.65982 32.3421 8.95131 33.2143 10.0376C33.6509 10.5814 33.9822 11.0662 34.2014 11.4607C34.434 11.8791 34.5 12.1255 34.5 12.2168Z",
    fill: "#F0F1F2",
    stroke: "#1C4685"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4302 12.0855C24.4302 15.557 21.0612 18.3712 17.5004 18.3712C13.9396 18.3712 10.6244 15.557 10.6244 12.0855C10.6244 8.61401 13.9396 5.7998 17.5004 5.7998C21.0612 5.7998 24.4302 8.61401 24.4302 12.0855Z",
    fill: "#1C4685"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4168 12.2179C20.4168 13.919 19.111 15.2979 17.5001 15.2979C15.8893 15.2979 14.5835 13.919 14.5835 12.2179C14.5835 10.5169 15.8893 9.13794 17.5001 9.13794C19.111 9.13794 20.4168 10.5169 20.4168 12.2179Z",
    fill: "#092F68"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.4449,
    cy: 10.8979,
    rx: 1.94444,
    ry: 1.76,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45846 23.5309C3.93394 22.927 3.99824 22.0123 4.60209 21.4878L28.246 0.949809C28.8499 0.425286 29.7646 0.489594 30.2891 1.09344C30.8136 1.69729 30.7493 2.61201 30.1455 3.13653L6.50155 23.6745C5.8977 24.199 4.98298 24.1347 4.45846 23.5309Z",
    fill: "#1C4685"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeNo);
export default __webpack_public_path__ + "static/media/eye_no.677d3a8b55567972a1583549a700beb8.svg";
export { ForwardRef as ReactComponent };